"use client";

import React, { Suspense } from "react";
import Registration from "@packages/shared-pages/registerpage";
import RegisterPageSkeleton from "@packages/shared-components/skeleton/register-page-skeleton";

const Registrationpage = () => {
  return (
    <Suspense fallback={<RegisterPageSkeleton />}>
      <Registration />
    </Suspense>
  );
};

export default Registrationpage;
